import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#078930",
  d: "M40 20c0 11.043-8.95 19.995-19.99 20h-.217a20.181 20.181 0 0 1-5.22-.744A20.006 20.006 0 0 1 0 20C0 8.956 8.952 0 20 0h.01a19.939 19.939 0 0 1 14.527 6.264A19.982 19.982 0 0 1 40 20Z"
}, null, -1), o = /* @__PURE__ */ l("path", {
  fill: "#FCDD09",
  d: "M34.142 34.142A19.936 19.936 0 0 1 20.018 40h-.225a20.181 20.181 0 0 1-5.22-.744A20.007 20.007 0 0 1 0 20.204V20A19.938 19.938 0 0 1 5.858 5.858l28.284 28.284Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#DA121A",
  d: "m20.48 15.963.775 2.386a.505.505 0 0 0 .48.349h2.51a.504.504 0 0 1 .296.912l-2.03 1.473a.506.506 0 0 0-.183.565l.775 2.386a.505.505 0 0 1-.776.564l-2.03-1.475a.505.505 0 0 0-.594 0l-2.03 1.475a.504.504 0 0 1-.776-.564l.776-2.386a.506.506 0 0 0-.184-.565l-2.03-1.475a.504.504 0 0 1 .297-.912h2.509a.505.505 0 0 0 .48-.349l.775-2.386a.505.505 0 0 1 .96.002Z"
}, null, -1), h = [
  n,
  o,
  c
];
function s(i, r) {
  return e(), t("svg", a, [...h]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
